module.exports = __webpack_public_path__ + "static/img/15.aee8f05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/15.jpg
// module id = cEKe
// module chunks = 1